import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  return {
    needed: jsonNode._id === 'ResourceComponent',
    logData: {
      msg: `ResourceComponent is a plugin component and should not be stored in jsonNodes.`,
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      jsonNode._id = 'Resource';
    },
  };
};
